import { AccessControl } from '@clerk/access-control'

const $AC = new AccessControl({
  Advertiser: {
    can: [
      'role:advertiser',
      'feature:marketing:campaigns',
      'feature:marketing:dashboard',
      'feature:marketing:videos',
      'feature:users:users',
      'feature_group:marketing',
      'feature_group:users',
      'operation:update:videos:video',
    ],
  },
  /**
   * Advertiser role created for Goldfish Ads
   * to get them onto the platform so they could
   * monitor their first campaign.
   */
  Advertising: {
    can: [
      'role:advertising',
      'feature:marketing:*',
      'feature_group:marketing',
      'operation:create:campaigns:campaign',
      'operation:create:videos:video',
      'operation:update:campaigns:campaign',
      'operation:update:campaigns:campaign:details',
      'operation:update:videos:video',
    ],
  },
  Admin: {
    can: [
      'role:admin',
      'feature:stores:stores',
      'feature:users:users',
      'feature_group:users',
      'operation:update:users:user',
    ],
  },
  'Call Contractor': {
    can: [
      'role:call_contractor',
      'feature:devices:callQueue',
      'feature:stores:store:attributes',
      'feature:stores:store:basic',
      'feature:stores:store:branding',
      'feature:stores:store:hours',
      'feature:stores:store:lanes',
      'feature:stores:store:layout',
      'feature:stores:store:loop',
      'feature:stores:store:maintenance',
      'feature:stores:store:notifications',
      'feature:stores:store:wifi',
      'feature:stores:stores',
      'feature_group:devices',
      'feature_group:stores',
      'operation:read:device:wifi_scan',
      'operation:read:stores:detail:*',
      'operation:read:stores:store:lanes',
      'operation:read:stores:store:lanes:details',
      'operation:update:stores:store',
      'operation:update:stores:store:lanes:details',
      'operation:update:stores:store:maintenance:issueOwner',
      'operation:update:stores:store:notifications',
      'operation:update:stores:store:wifi',
      'operation:update:stores:store:maintenance:storeNote',
    ],
  },
  'Device Install Contractor': {
    can: [
      'role:device_install_contractor',
      'feature:stores:store:attributes',
      'feature:stores:store:basic',
      'feature:stores:store:lanes',
      'feature:stores:store:layout',
      'feature:stores:store:wifi',
      'feature:stores:stores',
      'feature:stores:stores:iTDetail',
      'feature_group:management',
      'operation:delete:stores:detail:lanes',
      'operation:read:device:wifi_scan',
      'operation:read:devices:device:details',
      'operation:read:stores:detail:*',
      'operation:read:stores:store:lanes',
      'operation:read:stores:store:lanes:details',
      'operation:update:stores:store',
      'operation:update:stores:store:basic:isInstalled',
      'operation:update:stores:store:basic:installDate',
      'operation:update:stores:store:lanes:details',
      'operation:update:stores:store:wifi',
    ],
  },
  'Device Issue Admin': {
    can: [
      'role:device_issue_admin',
      'feature:devices:callQueue',
      'feature:pricing:store_search',
      'feature:stores:store:basic',
      'feature:stores:store:hours',
      'feature:stores:store:lanes',
      'feature:stores:store:maintenance',
      'feature:stores:stores',
      'feature:stores:store:notifications',
      'feature_group:devices',
      'feature_group:management',
      'feature_group:stores',
      'operation:read:retailers:retailers',
      'operation:read:stores:store:lanes:details',
      'operation:update:stores:store',
      'operation:update:stores:store:maintenance',
    ],
  },
  IT: {
    can: [
      'role:it',
      'feature:devices:devices',
      'feature:devices:issues',
      'feature:stores:store:basic',
      'feature:stores:store:lanes',
      'feature:stores:store:wifi',
      'feature:stores:stores',
      'feature:stores:stores:iTDetail',
      'feature_group:devices',
      'feature_group:management',
      'operation:read:devices:device:details',
      'operation:read:stores:detail:*',
      'operation:read:stores:store:lanes',
      'operation:update:stores:store',
      'operation:update:stores:store:wifi',
    ],
  },
  'Network Health Contractor': {
    can: [
      'role:network_health_contractor',
      'feature:stores:store:attributes',
      'feature:stores:store:basic',
      'feature:stores:store:lanes',
      'feature:stores:store:layout',
      'feature:stores:store:maintenance',
      'feature:stores:store:wifi',
      'feature:stores:stores',
      'feature:stores:stores:iTDetail',
      'feature:stores:store:maintenance',
      'feature_group:management',
      'operation:delete:stores:detail:lanes',
      'operation:read:device:wifi_scan',
      'operation:read:devices:device:details',
      'operation:read:stores:detail:*',
      'operation:read:stores:store:lanes',
      'operation:read:stores:store:lanes:details',
      'operation:update:devices:device:controlPanel',
      'operation:update:stores:store',
      'operation:update:stores:store:basic:isInstalled',
      'operation:update:stores:store:lanes:details',
      'operation:update:stores:store:wifi',
    ],
  },
  'Popspots Read Only': {
    can: [
      'feature_group:*',
      'feature:*',
      'operation:read:*',
    ],
  },
  Retailer: {
    can: [
      'role:retailer',
      'feature:banners',
      'feature:stores:store:basic',
      'feature:stores:store:branding',
      'feature:stores:store:hours',
      'feature:stores:store:lanes',
      'feature:stores:store:layout',
      'feature:stores:store:loop',
      'feature:stores:store:metrics',
      'feature:stores:stores',
      'operation:create:campaigns:campaign:banners',
    ],
  },
  'Super Admin': {
    can: [
      'role:super_admin',
      'feature:*',
      'feature_group:*',
      'operation:*',
      'topbar:createBtn:view',
      'topbar:jump:view',
    ],
  },
  'Stockcheck Read Only': {
    can: [
      'role:stockcheck_read_only',
      'feature:merchandise:dashboard',
      'feature:merchandise:products',
      'feature:merchandise:retailers',
      'feature:merchandise:stores',
      'feature:stockcheck:audits',
      'feature:stockcheck:issues',
      'feature:stockcheck:planograms',
      'feature:stockcheck:planograms',
      'feature_group:merchandise',
      'operation:read:retailers:retailers',
    ],
  },
  'Stockcheck Admin': {
    can: [
      'role:stockcheck_admin',
      'feature:products:*',
      'feature:stockcheck:*',
      'feature:users:*',
      'feature_group:products',
      'feature_group:stockcheck',
      'feature_group:users',
      'operation:create:brands:brand',
      'operation:create:pogs:pog',
      'operation:create:products:product',
      'operation:create:vendors:vendor',
      'operation:read:retailers:retailers',
      'operation:update:brands:brand',
      'operation:update:pogs:pog',
      'operation:update:products:product',
      'operation:update:vendors:vendor',
    ],
  },
  'Store Admin': {
    can: [
      'role:store_admin',
    ],
  },
  Vendor: {
    can: [
      'role:vendor',
      'feature:marketing:campaigns', // required for marketing:campaigns
      'feature:marketing:dashboard',
      'feature:marketing:videos',
      'feature:merchandise:dashboard',
      'feature:merchandise:products',
      'feature:merchandise:retailers',
      'feature:merchandise:stores',
      'feature:stockcheck:metrics',
      'feature:stores:store:basic',
      'feature:users:users',
      'feature_group:marketing',
      'feature_group:marketing',
      'feature_group:merchandise',
      'feature_group:users',
      'operation:update:merchandise:stores:nextAudit',
      // 'feature:marketing:stores',
    ],
  },
  Wholesaler: {
    // copied from 'retailer'
    can: [
      'role:wholesaler',
      'feature:banners',
      'feature:marketing:campaigns',
      'feature:marketing:dashboard',
      'feature:marketing:stores',
      'feature:marketing:videos',
      'feature:stores:store:basic',
      'feature:stores:store:branding',
      'feature:stores:store:hours',
      'feature:stores:store:lanes',
      'feature:stores:store:layout',
      'feature:stores:store:loop',
      'feature:stores:store:metrics',
      'feature:stores:stores',
      // 'feature_group:marketing',
      'operation:create:campaigns:campaign:banners',
    ],
  },
})

export default $AC



// WEBPACK FOOTER //
// ./src/store/modules/auth/utils/AccessList.js